export const ratio = function (view, magnet, ref, options) {
    const ratio = options.ratio != null ? options.ratio : 0.5;
    return view.getPointAtRatio(ratio);
};
//# sourceMappingURL=ratio.js.map